const STYLES_BY_TYPE = {
  DATA_AGENT_COLUMN_CALL_TO_ACTION: {
    columnHighlightColor: 'fill-accent-purple-subtle-alt'
  }
};
export const getColumnCallToActionStyles = type => STYLES_BY_TYPE[type];